<template>
  <div>
    <div>
      <lwf-autocomplete
        v-bind="mergedProps"
        ref="select"
        :value="value"
        :options="clientOptions"
        v-on="vListeners"
      >
        <template #option="scope">
          <q-item
            v-ripple
            dense
            v-bind="scope.itemProps"
            v-on="scope.itemEvents"
          >
            <q-item-section>
              <card-site
                :site="scope.opt"
                class="no-shadow bg-transparent"
                :active="scope.itemProps.active"
              />
            </q-item-section>
          </q-item>
          <q-separator />
        </template>
      </lwf-autocomplete>
      <q-tooltip v-if="vReadonly">
        Vous ne pouvez pas lister les sites
      </q-tooltip>
    </div>
    <card-site
      v-if="showSelectedCard && value && typeof value === 'object'"
      specialties
      :site="value"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import CardSite from 'components/Card/CardSite'
import LwfAutocomplete from 'components/core/LwfAutocomplete'
import { toast } from '@/utils/ui'
import { USER_AGENCY_FETCH_SITES } from '@/store/modules/user/agency/action-types'
import { modalSite } from '@/utils/ui/modal'
import { ACCOUNT_RIGHT_CREATE_SITE } from '@/consts/rights'
import validateProxyMixin from '@/mixins/validateProxyMixin'

const storeUser = createNamespacedHelpers('user')
const storeUserAgency = createNamespacedHelpers('user/agency')
/**
 * Autocomplete pour le sites
 */
export default {
  name: 'AutocompleteSite',
  components: { LwfAutocomplete, CardSite },
  mixins: [validateProxyMixin],
  inheritAttrs: false,
  props: {
    /**
     * @model
     **/
    value: {
      type: [String, Object, Array],
      default: undefined
    },
    /**
     * Focus automatiquement le select s'il n'a pas de valeur
     **/
    autofocus: Boolean,
    /**
     * Autorise l'ajout de site
     **/
    allowAdd: Boolean,
    /**
     * Affiche la section sous forme de card
     **/
    showSelectedCard: Boolean,
    /**
     * Filtre la liste par client
     **/
    client: {
      type: [Object, String, Array],
      default: undefined
    }
  },
  computed: {
    ...storeUser.mapGetters({
      isGranted: 'isGranted'
    }),
    ...storeUserAgency.mapGetters({
      options: 'sites'
    }),
    ...storeUserAgency.mapState({
      fetching: 'fetching'
    }),
    vOn () {
      const on = {}
      if (!this.readonly && this.allowAdd && this.isGranted(ACCOUNT_RIGHT_CREATE_SITE)) {
        on.ajouter = this.onAjouter
      }
      return on
    },
    vReadonly () {
      return !this.fetching.sites && this.clientOptions.length === 0
    },
    slugClient () {
      const { client } = this
      if (!client) return null
      return typeof client === 'string' || Array.isArray(client)
        ? client
        : client.slug
    },
    clientOptions () {
      const { slugClient, options } = this
      if (!slugClient) return options
      return this.options.filter((o) => (Array.isArray(slugClient)) ? slugClient.includes(o.customer.slug) : slugClient === o.customer.slug)
    },
    vListeners () {
      return {
        ...this.$listeners,
        ...this.vOn
      }
    },
    mergedProps () {
      const hasOpt = this.options && this.options.length !== 0
      return {
        clearable: true,
        label: 'Site',
        beforeIcon: 'fa fa-loading',
        disable: !hasOpt,
        loading: this.fetching.sites === true,
        ...this.$attrs
      }
    }
  },
  watch: {
    slugClient: {
      immediate: true,
      handler (v) {
        if (!v) return
        if (this.$attrs.multiple) return
        const { value, clientOptions } = this
        const _v = _.isObject(value)
          ? value.slug
          : value
        if (!this.vReadonly && !clientOptions.find((o) => o.slug === _v)) {
          this.$emit('input', null)
        }
      }
    }
  },
  async created () {
    if (this.options.length === 0) {
      try {
        await this.fetchSites()
      } catch (e) {
        toast.negative(`Échec de la mise à jour de la liste des sites`)
      }
    }
    if (this.autofocus && !this.value && this.$refs.select) this.$refs.select.focus()
  },
  methods: {
    ...storeUserAgency.mapActions({
      fetchSites: USER_AGENCY_FETCH_SITES
    }),
    /**
     * Bascule en mode "nouveau site"
     */
    onAjouter () {
      modalSite()
    },
    /**
     * Soumission d'un site
     * TODO traitement back
     */
    onSubmit () {

    }
  }
}
</script>

<style scoped>

</style>
